import styled from 'styled-components';

export default styled.span`
        font-weight: 600;
`;



// WEBPACK FOOTER //
// ./src/components/styles/StrongText.js